import { PluginFunction, PluginObject } from 'vue/types/plugin';
import ToastApi from './ToastApi'
import { ToastOptions } from './types/index';

const globalOptions: ToastOptions = {
  allowMultiple: true,
  maxItems: 5,
  timeout: 3500,
  position: 'bottom-left',
  left: 44,
  right: 44,
  top: 38,
  bottom: 38,
};

const CgToast: PluginFunction<ToastOptions> | PluginObject<ToastOptions> = (Vue, options?: ToastOptions) => {
  const defaultOptions = { ...globalOptions, ...options };
  const toast = new ToastApi(Vue, defaultOptions);

  Vue.$cgToast = toast;
  Vue.prototype.$cgToast = toast;
};

export default CgToast;
